import React from 'react';
import { SettingAccountPage } from '../Pages/Settings/SettingAccountPage';
import SettingPasswordPage from '../Pages/Settings/SettingPasswordPage';
import NotificationPage from '../Pages/Notification/NotificationPage';
import SettingAccessDetailPage from '../Pages/Settings/SettingAccessDetailPage';
import SettingAccessPage from '../Pages/Settings/SettingAccessPage';

const SettingRouter = [
  {
    path: '/change-password',
    element: <SettingPasswordPage />,
  },
  {
    path: '/notification',
    element: <NotificationPage />,
  },
  {
    path: '/settings/profile',
    element: <SettingAccountPage />,
  },


  {
    path: '/settings/access',
    element: <SettingAccessPage />,
  },
  {
    path: '/settings/access/:id',
    element: <SettingAccessDetailPage />,
  },
];

export default SettingRouter;
